module.exports = __webpack_public_path__ + "static/d1-32d9457ba2a949bf9eec9b00d054b67a.png";